import React from 'react';
import LogoWide from './logo-wide.inline.svg';
import LookingGlass from './looking-glass.inline.svg';
import MenuIcon from './menu-icon.inline.svg';

import SocialFacebook from './social/facebook.inline.svg';
import SocialInstagram from './social/instagram.inline.svg';
import SocialLinkedIn from './social/linkedin.inline.svg';
import SocialTwitter from './social/twitter.inline.svg';
import SocialYoutube from './social/youtube.inline.svg';

import classNames from 'classnames';

import { Link } from 'gatsby';

const searchUrls = {
  'en': '/en/about-europalia/search',
  'nl': '/nl/over-europalia/zoeken',
  'fr': '/fr/a-propos-deuropalia/chercher',
}

export class Navigation extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      languagesVisible: false
    };
  }

  get languages () {
    return (
      <>
        <Link to={ this.props.slugs.nlSlug }>NL</Link>
        <Link to={ this.props.slugs.frSlug }>FR</Link>
        <Link to={ this.props.slugs.enSlug }>EN</Link>
      </>
    )
  }

  get social () {
    return (
      <>
        <a target="_blank" href="https://www.facebook.com/Europalia"><SocialFacebook /></a>
        <a target="_blank" href="https://instagram.com/europalia"><SocialInstagram /></a>
        <a target="_blank" href="https://www.linkedin.com/company/europalia-international/"><SocialLinkedIn /></a>
        <a target="_blank" href="https://twitter.com/EUROPALIA2021"><SocialTwitter /></a>
        <a target="_blank" href="https://www.youtube.com/user/EuropaliaFestival"><SocialYoutube /></a>
      </>
    )
  }

  get className () {
    return classNames({
      'nav--main': true,
      'nav--show-languages': this.state.languagesVisible
    })
  }

  languageToggle = (e) => {
    e.preventDefault();
    this.setState({ languagesVisible: !this.state.languagesVisible });
  }

  enter = (festival) => {
    if (this.timeout) clearTimeout(this.timeout);
    this.setState({ festival: festival.id });
  }

  leave = () => {
    this.timeout = setTimeout(() => {
      this.setState({ festival: null });
    }, 2000);
  }

  toggle = () => {
    let overlay = !this.state.overlay;
    this.setState({ overlay });
  }

  render () {
    return (
      <>
        <header onMouseLeave={this.leave}>
          { this.renderMainNavigation() }
          { this.props.festivals.map(festival => this.renderSubNavigation(festival)) }
        </header>
        { this.renderMobileOverlay() } 
      </>
    )
  }

  renderMainNavigation = () => (
    <nav className={this.className}>
      <div className="nav--main__left">
        <Link to={`/${this.props.language}`}>
          <LogoWide />
        </Link>
      </div>
      <div className="nav--main__right">
        { this.props.festivals.map(festival => (
          <span className="nav--main__item" id={festival.id} onMouseOver={() => this.enter(festival)}>{ festival.title }</span>
        )) }
        
        <Link className="nav--main__item nav--main__search" to={`${searchUrls[this.props.language]}`}><LookingGlass/></Link>
        <a className="nav--main__item nav--main__toggle" onClick={this.toggle}><MenuIcon /></a>

        <a href="#" onClick={this.languageToggle} className="nav--main__item nav--main__right__language">
          {this.props.language}<span>{ this.languages }</span>
        </a>
      </div>
    </nav>
  )

  renderSubNavigation = (festival) => {
    let className = classNames({
      'nav--sub': true,
      'nav--sub--active': festival.id === this.state.festival
    });

    return (
      <nav className={className}>
        <div className="nav--sub__left">
          { festival.title }
        </div>
        <div className="nav--sub__center">
          { festival.pages.map(page => <Link to={page.slug}>{page.title}</Link>) }
        </div>
        <div className="nav--sub__right">
          { this.social }
        </div>
      </nav>
    );
  }

  renderMobileOverlay = () => {
    let className = classNames({
      'nav__overlay': true,
      'nav__overlay--visible': this.state.overlay
    });

    return (
      <nav className={className}>
        <div className="nav__overlay__language">
          { this.languages }
        </div>
        { this.props.festivals.map((festival, index) => {
         let className = classNames({
          'nav__overlay__festival': true,
          'nav__overlay__festival--visible': this.state.openedFestival === index
        });

        return (
          <div className={className}>
            <div className="nav__overlay__name" onClick={() => this.setState({ openedFestival: index }) }>
              { festival.title }
            </div>
            <div className="nav__overlay__sub">
              { festival.pages.map(page => <Link to={page.slug}>{page.title}</Link>) }
            </div>
          </div>
         );
        }) }
      </nav>
    );
  }
}
